module.exports = __webpack_public_path__ + "img/background-0-3-mb.f0c83d66.jpg";